import React, { useEffect, useRef, useState } from 'react';
import RedButton from '../../../Objects/RedButton/RedButton';
import { firebaseCommands } from '../Game';
import { setValue } from '../../../firebase';
import { globalVars } from '../../../App';
import CommonButton, { btnColors, btnSizes } from '../../../Objects/CommonButton/CommonButton';

export const gameStatus_button = {
    idle: 1,
    playing: 2,
    guessing: 3,
    results: 4,
    showEnd: 5,
}

const titles = [
    "PREMI PER GENERARE",
    "CONCENTRATI...",
    "PARLA ORA!",
    "ATTESA RISULTATI..."
]

//dopo ogni azione i pulsanti restano bloccati per un secondo: niente doppi tocchi né comandi troppo ravvicinati
const LOCK_MS = 1000;

const Game_button = ({game, changeGame}) => {
    let redBtn = useRef(null);

    const gameRef = useRef(game);

    //Il blocco è un orario (performance.now è monotono: non risente dell'ora del telefono) e si imposta subito, dentro il
    //gestore del click. Niente stato e niente timer da annullare: nessuna riattivazione anticipata e nessun tocco che
    //passa prima del render. Parte bloccato: appena compare la schermata il pulsante non risponde per un secondo
    const lockedUntil = useRef(performance.now() + LOCK_MS);
    const canAct = () => performance.now() >= lockedUntil.current;
    const tryLock = () => {
        if (!canAct()) {
            return false;
        }
        lockedUntil.current = performance.now() + LOCK_MS;
        return true;
    };

    const [curScore, setCurScore] = useState(0);

    useEffect(() => {
        gameRef.current = game; // Aggiorna il riferimento allo stato più recente di game ogni volta che cambia
    }, [game]);

    useEffect(() => {
        //console.log("JUST LOADED ", game.loadCurScore)
        if("loadCurScore" in game) {
            //ha appena caricato lo stato salvato (riconnessione): ripristina il punteggio invece di sovrascriverlo con 0
            setCurScore(game.loadCurScore || 0);
            delete game.loadCurScore;
        } else {
            const states = {
                game,
                curScore
            }
            setValue(globalVars.code+"/btn_status", states);
        }
    }, [game, curScore])

    useEffect(() => {
        const redBtnElement = redBtn.current;
        if (redBtnElement) {
            // Aggiungi gli event listener
            redBtnElement.addEventListener('click', redBtnClick);
            redBtnElement.addEventListener('touchstart', redBtnClick);

            // Rimuovi gli event listener quando il componente viene smontato o le dipendenze cambiano
            return () => {
                redBtnElement.removeEventListener('click', redBtnClick);
                redBtnElement.removeEventListener('touchstart', redBtnClick);
            };
        }
    }, [game]);


    const redBtnClick = (event) => {
        //console.log("btn event")
        // Verifica se l'evento è un tocco o un click del mouse (touchstart e click dello stesso tocco: il secondo trova il blocco)
        if((event.type === 'click' || (event.touches && event.touches.length == 1)) && tryLock()) {
            const currentGame = gameRef.current;
            // Controlla lo stato del gioco e invia il comando corrispondente
            // Lo stato da controllare deve essere lo stato locale del bottone
            // Invia il comando come funzione firebase al display

            //lo stato del bottone corrisponde allo stato del database
            //console.log("cur event: "+event.type);
            if(currentGame.step == gameStatus_button.idle) {
                // GENERA LA PAROLA
                if(currentGame.useDouble) {
                    firebaseCommands.doubleWord.call(firebaseCommands.creator);
                    setTimeout(() => {
                        changeGame(prevStatus => ({
                            ...prevStatus,
                            step: gameStatus_button.playing,
                            double: currentGame.double - 1,
                            useDouble: false
                        }));
                    }, 100);
                } else {
                    firebaseCommands.generateWord.call(firebaseCommands.creator);
                    setTimeout(() => {
                        changeGame(prevStatus => ({
                            ...prevStatus,
                            step: gameStatus_button.playing
                        }));
                    }, 100);
                }

                setValue(globalVars.code+"/status", gameStatus_button.playing);

                return;
            }

            if(currentGame.step == gameStatus_button.playing) {
                //STOP TIMER, INDOVINA LA PAROLA
                firebaseCommands.startGuessing.call(firebaseCommands.creator);
                setValue(globalVars.code+"/status", gameStatus_button.guessing);
                setTimeout(() => {
                    changeGame(prevStatus => ({
                        ...prevStatus,
                        step: gameStatus_button.guessing
                    }));
                }, 200);

                return;
            }
        }
    }

    const showResults = (wait=2000) => {
        changeGame(prevStatus => ({
            ...prevStatus,
            step: gameStatus_button.results
        }));
        //chiama subito la funzione per evitare problemi con le disconnessioni
        //passa l'attesa come parametro e metti un wait alla ricezione della chiamata
        //console.log(wait);
        firebaseCommands.showResults.call(firebaseCommands.creator, true, wait);
    }

    return (
        <div className='game_button'>

            {game.step != 1 && <span className='title-txt' id='redBtn_title'>{titles[game.step-1]}</span>}
            {game.step == 1 && <span className='title-txt' id='redBtn_title-1'>{titles[game.step-1]}</span>}

            {(game.step == gameStatus_button.idle || game.step == gameStatus_button.playing) && <RedButton
                ref={redBtn}
                lit={game.step == gameStatus_button.playing}
                label={game.step == gameStatus_button.idle ? "Premi per generare la parola" : "Premi per fermare il tempo e indovinare"}
            />}

            {game.step == gameStatus_button.idle && <CommonButton
                id={"doubleBtn"} txt={"RADDOPPIO"}
                check={!!game.useDouble}
                checkTone="#0BAC3D"
                color={
                    game.useDouble ? btnColors.green :
                    game.double > 0 && curScore >= 2 ? btnColors.orange :
                    btnColors.grey
                }
                size={btnSizes.default}
                click={() => {
                    //ATTIVA O DISATTIVA RADDOPPIO (solo se il blocco è scaduto, ma senza riattivarlo)
                    if(game.double > 0 && curScore >= 2 && canAct()) {
                        changeGame(prevStatus => ({
                            ...prevStatus,
                            useDouble: !game.useDouble
                        }));
                    }

                }}>
            </CommonButton>}
            {game.step == gameStatus_button.guessing && <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column'}}>
                <CommonButton id={"correct_ans"} txt={"CORRETTA"} color={btnColors.green} size={btnSizes.choice1} click={() => {
                    //RISPOSTA CORRETTA
                    if (tryLock()) {
                        setCurScore(curScore+1);
                        firebaseCommands.correct.call(firebaseCommands.creator);
                        setValue(globalVars.code+"/status", gameStatus_button.idle);

                        if(game.last) {
                            showResults();
                        } else {
                            changeGame(prevStatus => ({
                                ...prevStatus,
                                step: gameStatus_button.idle
                            }));
                        }
                    }

                }}></CommonButton>
                <div style={{height: "20px"}}></div>
                <CommonButton id={"wrong_ans"} txt={"ERRATA"} color={btnColors.red} size={btnSizes.choice2} click={() => {
                    //RISPOSTA ERRATA
                    if (tryLock()) {
                        if(curScore > 0) {
                            setCurScore(curScore-1);
                        }
                        firebaseCommands.wrong.call(firebaseCommands.creator);
                        setValue(globalVars.code+"/status", gameStatus_button.idle);
                        if(game.last) {
                            showResults();
                        } else {
                            changeGame(prevStatus => ({
                                ...prevStatus,
                                step: gameStatus_button.idle,
                            }));
                        }
                    }

                }}></CommonButton>
                <div style={{height: "30px"}}></div>
                <CommonButton id={"skip"} txt={game.last ? "SALTA" : "PASSO"} color={btnColors.orange} size={btnSizes.default} click={() => {
                    if((game.skips > 0 || game.last) && tryLock()) {
                        //PASSO
                        firebaseCommands.skip.call(firebaseCommands.creator);
                        setValue(globalVars.code+"/status", gameStatus_button.results);
                        if(game.last) {
                            showResults(0);
                        } else {
                            changeGame(prevStatus => ({
                                ...prevStatus,
                                skips: game.skips -1,
                                step: gameStatus_button.idle,
                            }));
                        }
                    }

                }} enabled={game.skips > 0 || game.last}></CommonButton>
            </div>}

            {game.step == gameStatus_button.showEnd && <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column'}}>
                <CommonButton
                    id="replay"
                    txt="Gioca ancora!"
                    color={btnColors["orange"]}
                    size={btnSizes["default-wide"]}
                    click={() => {
                        firebaseCommands.replay.call(firebaseCommands.creator);
                    }}
                />
                <div style={{height: "15px"}}></div>
                <CommonButton
                    id="goHome"
                    txt="Torna alla home"
                    color={btnColors["blue"]}
                    size={btnSizes["wide"]}
                    click={() => {
                        firebaseCommands.endGame.call(firebaseCommands.creator);
                    }}
                />
            </div>}
        </div>
    );
}

export default Game_button;
